/**
 * ChevronUpIcon/index.js
 * desc: navigation up arrow
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const ChevronUpIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="chevron-up icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.chevronUp.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 12 8" xmlns="http://www.w3.org/2000/svg"><path d="M6 0L0 6l1.41 1.41L6 2.83l4.59 4.58L12 6 6 0z"/></svg>
    </IconButton>
);


export default ChevronUpIcon;
